import type { OptionsMap } from '@openx/types/options.ts';
import type { Section } from '../context/types.ts';

export const filterOptions = (initialState: Section, apiOptionsMap: OptionsMap): Section => {
  const allowedKeys = new Set(Object.keys(apiOptionsMap));

  return {
    ...initialState,
    elements: initialState.elements
      .filter(element => allowedKeys.has(element.mainOption.key))
      .map(element => ({
        ...element,
        subOptions: element.subOptions?.filter(sub => allowedKeys.has(sub.key)),
      })),
  };
};
